<template>
  <div className="json-editor">
    <textarea ref="textarea"></textarea>
  </div>
</template>
<script>
window.jsonlint = require("jsonlint");
import CodeMirror from 'codemirror';
import 'codemirror/addon/lint/lint.css';
import 'codemirror/addon/lint/lint.js';
import 'codemirror/addon/lint/json-lint';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/foldgutter.css';

export default {
  name: 'JsonEditor',
  data() {
    return {
      jsonEditor: null
    }
  },
  props: {
    value: [Object,String],
    input: Function
  },
  watch: {
    // 监听 value 的变化
    value(value) {
      const editorValue = this.jsonEditor.getValue();
      if (value !== editorValue) {
        this.setValue(value);
      }
    }
  },
  mounted() {
    this.jsonEditor = CodeMirror.fromTextArea(this.$refs.textarea, {
      lineNumbers: true,
      mode: 'application/json',
      foldGutter: true,
      gutters: ['CodeMirror-lint-markers', 'CodeMirror-foldgutter'],
      lint: true,
      autoRefresh: true, // 自动触发刷新
      tabSize: 4,
      matchBrackets: true,
      indentUnit: 4
    });
    // 将json文件格式化显示
    this.setValue(this.value);
    // 当输入框内容发生变化 更新value值
    this.jsonEditor.on('change', cm => {
      this.handleInput(cm);
      this.$emit('changed', cm.getValue());
      this.$emit('input', cm.getValue());
    });
  },
  methods: {
    getValue() {
      return this.jsonEditor.getValue()
    },
    setValue(value) {
      try {
        let newVal = JSON.stringify(value, null, 4);
        this.jsonEditor.setValue(newVal);
      } catch (e) {
        this.jsonEditor.setValue(value);
      }
    },
    handleInput(e) {
      if (this.changeFn) {
        this.changeFn(e.getValue())
      }
    },
    refresh() {
      /*
       * refresh: Fires when the editor is refreshed or resized.
       *          Mostly useful to invalidate cached values that depend on the editor or character size.
       */
      this.jsonEditor && this.jsonEditor.refresh();
    },
  }
}
</script>

<style scoped>

</style>
